/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as SetPasswordRouteImport } from './routes/set-password'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppSplatRouteImport } from './routes/_app/$'
import { Route as AppNoPermissionsRouteImport } from './routes/_app/no-permissions'
import { Route as AppNoWebsitesRouteImport } from './routes/_app/no-websites'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as SignupIndexRouteImport } from './routes/signup.index'
import { Route as SignupCheckEmailRouteImport } from './routes/signup.check-email'
import { Route as VerifyEmailIndexRouteImport } from './routes/verify-email.index'
import { Route as VerifyEmailResendRouteImport } from './routes/verify-email.resend'
import { Route as AppAccountAffiliateRouteImport } from './routes/_app/account/affiliate'
import { Route as AppAccountAnalyticsRouteImport } from './routes/_app/account/analytics'
import { Route as AppAccountUsersRouteImport } from './routes/_app/account/users'
import { Route as AppSupportIndexRouteImport } from './routes/_app/support/index'
import { Route as AppSupportTicketIdRouteImport } from './routes/_app/support/$ticketId'
import { Route as AppWebsitesWebsiteIdRouteImport } from './routes/_app/websites/$websiteId'
import { Route as AppWebsitesNewRouteImport } from './routes/_app/websites/new'
import { Route as AppAccountBillingIndexRouteImport } from './routes/_app/account/billing/index'
import { Route as AppIntegrationsHubspotCallbackRouteImport } from './routes/_app/integrations/hubspot/callback'
import { Route as AppIntegrationsSalesforceCallbackRouteImport } from './routes/_app/integrations/salesforce/callback'
import { Route as AppIntegrationsSlackCallbackRouteImport } from './routes/_app/integrations/slack/callback'
import { Route as AppIntegrationsZohoCallbackRouteImport } from './routes/_app/integrations/zoho/callback'
import { Route as AppWebsitesWebsiteIdAnalyticsRouteImport } from './routes/_app/websites/$websiteId/analytics'
import { Route as AppWebsitesWebsiteIdConversationsRouteImport } from './routes/_app/websites/$websiteId/conversations'
import { Route as AppWebsitesWebsiteIdCustomDataRouteImport } from './routes/_app/websites/$websiteId/custom-data'
import { Route as AppWebsitesWebsiteIdIntegrationsRouteImport } from './routes/_app/websites/$websiteId/integrations'
import { Route as AppWebsitesWebsiteIdKnowledgeRouteImport } from './routes/_app/websites/$websiteId/knowledge'
import { Route as AppWebsitesWebsiteIdLeadsRouteImport } from './routes/_app/websites/$websiteId/leads'
import { Route as AppWebsitesWebsiteIdSetupRouteImport } from './routes/_app/websites/$websiteId/setup'
import { Route as AppAccountBillingInvoicesInvoiceIdRouteImport } from './routes/_app/account/billing/invoices/$invoiceId'
import { Route as AppWebsitesWebsiteIdConversationsIndexRouteImport } from './routes/_app/websites/$websiteId/conversations/index'
import { Route as AppWebsitesWebsiteIdConversationsConversationIdRouteImport } from './routes/_app/websites/$websiteId/conversations/$conversationId'
import { Route as AppWebsitesWebsiteIdCustomDataIndexRouteImport } from './routes/_app/websites/$websiteId/custom-data/index'
import { Route as AppWebsitesWebsiteIdCustomDataCustomPageIdRouteImport } from './routes/_app/websites/$websiteId/custom-data/$customPageId'
import { Route as AppWebsitesWebsiteIdCustomDataNewRouteImport } from './routes/_app/websites/$websiteId/custom-data/new'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const SetPasswordRoute = SetPasswordRouteImport.update({
  id: '/set-password',
  path: '/set-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppSplatRoute = AppSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => AppRoute,
} as any)
const AppNoPermissionsRoute = AppNoPermissionsRouteImport.update({
  id: '/no-permissions',
  path: '/no-permissions',
  getParentRoute: () => AppRoute,
} as any)
const AppNoWebsitesRoute = AppNoWebsitesRouteImport.update({
  id: '/no-websites',
  path: '/no-websites',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const SignupIndexRoute = SignupIndexRouteImport.update({
  id: '/signup/',
  path: '/signup/',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupCheckEmailRoute = SignupCheckEmailRouteImport.update({
  id: '/signup/check-email',
  path: '/signup/check-email',
  getParentRoute: () => rootRouteImport,
} as any)
const VerifyEmailIndexRoute = VerifyEmailIndexRouteImport.update({
  id: '/verify-email/',
  path: '/verify-email/',
  getParentRoute: () => rootRouteImport,
} as any)
const VerifyEmailResendRoute = VerifyEmailResendRouteImport.update({
  id: '/verify-email/resend',
  path: '/verify-email/resend',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAccountAffiliateRoute = AppAccountAffiliateRouteImport.update({
  id: '/account/affiliate',
  path: '/account/affiliate',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountAnalyticsRoute = AppAccountAnalyticsRouteImport.update({
  id: '/account/analytics',
  path: '/account/analytics',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountUsersRoute = AppAccountUsersRouteImport.update({
  id: '/account/users',
  path: '/account/users',
  getParentRoute: () => AppRoute,
} as any)
const AppSupportIndexRoute = AppSupportIndexRouteImport.update({
  id: '/support/',
  path: '/support/',
  getParentRoute: () => AppRoute,
} as any)
const AppSupportTicketIdRoute = AppSupportTicketIdRouteImport.update({
  id: '/support/$ticketId',
  path: '/support/$ticketId',
  getParentRoute: () => AppRoute,
} as any)
const AppWebsitesWebsiteIdRoute = AppWebsitesWebsiteIdRouteImport.update({
  id: '/websites/$websiteId',
  path: '/websites/$websiteId',
  getParentRoute: () => AppRoute,
} as any)
const AppWebsitesNewRoute = AppWebsitesNewRouteImport.update({
  id: '/websites/new',
  path: '/websites/new',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountBillingIndexRoute = AppAccountBillingIndexRouteImport.update({
  id: '/account/billing/',
  path: '/account/billing/',
  getParentRoute: () => AppRoute,
} as any)
const AppIntegrationsHubspotCallbackRoute =
  AppIntegrationsHubspotCallbackRouteImport.update({
    id: '/integrations/hubspot/callback',
    path: '/integrations/hubspot/callback',
    getParentRoute: () => AppRoute,
  } as any)
const AppIntegrationsSalesforceCallbackRoute =
  AppIntegrationsSalesforceCallbackRouteImport.update({
    id: '/integrations/salesforce/callback',
    path: '/integrations/salesforce/callback',
    getParentRoute: () => AppRoute,
  } as any)
const AppIntegrationsSlackCallbackRoute =
  AppIntegrationsSlackCallbackRouteImport.update({
    id: '/integrations/slack/callback',
    path: '/integrations/slack/callback',
    getParentRoute: () => AppRoute,
  } as any)
const AppIntegrationsZohoCallbackRoute =
  AppIntegrationsZohoCallbackRouteImport.update({
    id: '/integrations/zoho/callback',
    path: '/integrations/zoho/callback',
    getParentRoute: () => AppRoute,
  } as any)
const AppWebsitesWebsiteIdAnalyticsRoute =
  AppWebsitesWebsiteIdAnalyticsRouteImport.update({
    id: '/analytics',
    path: '/analytics',
    getParentRoute: () => AppWebsitesWebsiteIdRoute,
  } as any)
const AppWebsitesWebsiteIdConversationsRoute =
  AppWebsitesWebsiteIdConversationsRouteImport.update({
    id: '/conversations',
    path: '/conversations',
    getParentRoute: () => AppWebsitesWebsiteIdRoute,
  } as any)
const AppWebsitesWebsiteIdCustomDataRoute =
  AppWebsitesWebsiteIdCustomDataRouteImport.update({
    id: '/custom-data',
    path: '/custom-data',
    getParentRoute: () => AppWebsitesWebsiteIdRoute,
  } as any)
const AppWebsitesWebsiteIdIntegrationsRoute =
  AppWebsitesWebsiteIdIntegrationsRouteImport.update({
    id: '/integrations',
    path: '/integrations',
    getParentRoute: () => AppWebsitesWebsiteIdRoute,
  } as any)
const AppWebsitesWebsiteIdKnowledgeRoute =
  AppWebsitesWebsiteIdKnowledgeRouteImport.update({
    id: '/knowledge',
    path: '/knowledge',
    getParentRoute: () => AppWebsitesWebsiteIdRoute,
  } as any)
const AppWebsitesWebsiteIdLeadsRoute =
  AppWebsitesWebsiteIdLeadsRouteImport.update({
    id: '/leads',
    path: '/leads',
    getParentRoute: () => AppWebsitesWebsiteIdRoute,
  } as any)
const AppWebsitesWebsiteIdSetupRoute =
  AppWebsitesWebsiteIdSetupRouteImport.update({
    id: '/setup',
    path: '/setup',
    getParentRoute: () => AppWebsitesWebsiteIdRoute,
  } as any)
const AppAccountBillingInvoicesInvoiceIdRoute =
  AppAccountBillingInvoicesInvoiceIdRouteImport.update({
    id: '/account/billing/invoices/$invoiceId',
    path: '/account/billing/invoices/$invoiceId',
    getParentRoute: () => AppRoute,
  } as any)
const AppWebsitesWebsiteIdConversationsIndexRoute =
  AppWebsitesWebsiteIdConversationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppWebsitesWebsiteIdConversationsRoute,
  } as any)
const AppWebsitesWebsiteIdConversationsConversationIdRoute =
  AppWebsitesWebsiteIdConversationsConversationIdRouteImport.update({
    id: '/$conversationId',
    path: '/$conversationId',
    getParentRoute: () => AppWebsitesWebsiteIdConversationsRoute,
  } as any)
const AppWebsitesWebsiteIdCustomDataIndexRoute =
  AppWebsitesWebsiteIdCustomDataIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppWebsitesWebsiteIdCustomDataRoute,
  } as any)
const AppWebsitesWebsiteIdCustomDataCustomPageIdRoute =
  AppWebsitesWebsiteIdCustomDataCustomPageIdRouteImport.update({
    id: '/$customPageId',
    path: '/$customPageId',
    getParentRoute: () => AppWebsitesWebsiteIdCustomDataRoute,
  } as any)
const AppWebsitesWebsiteIdCustomDataNewRoute =
  AppWebsitesWebsiteIdCustomDataNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AppWebsitesWebsiteIdCustomDataRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/set-password': typeof SetPasswordRoute
  '/$': typeof AppSplatRoute
  '/no-permissions': typeof AppNoPermissionsRoute
  '/no-websites': typeof AppNoWebsitesRoute
  '/settings': typeof AppSettingsRoute
  '/signup/check-email': typeof SignupCheckEmailRoute
  '/verify-email/resend': typeof VerifyEmailResendRoute
  '/signup/': typeof SignupIndexRoute
  '/verify-email/': typeof VerifyEmailIndexRoute
  '/account/affiliate': typeof AppAccountAffiliateRoute
  '/account/analytics': typeof AppAccountAnalyticsRoute
  '/account/users': typeof AppAccountUsersRoute
  '/support/$ticketId': typeof AppSupportTicketIdRoute
  '/websites/$websiteId': typeof AppWebsitesWebsiteIdRouteWithChildren
  '/websites/new': typeof AppWebsitesNewRoute
  '/support/': typeof AppSupportIndexRoute
  '/integrations/hubspot/callback': typeof AppIntegrationsHubspotCallbackRoute
  '/integrations/salesforce/callback': typeof AppIntegrationsSalesforceCallbackRoute
  '/integrations/slack/callback': typeof AppIntegrationsSlackCallbackRoute
  '/integrations/zoho/callback': typeof AppIntegrationsZohoCallbackRoute
  '/websites/$websiteId/analytics': typeof AppWebsitesWebsiteIdAnalyticsRoute
  '/websites/$websiteId/conversations': typeof AppWebsitesWebsiteIdConversationsRouteWithChildren
  '/websites/$websiteId/custom-data': typeof AppWebsitesWebsiteIdCustomDataRouteWithChildren
  '/websites/$websiteId/integrations': typeof AppWebsitesWebsiteIdIntegrationsRoute
  '/websites/$websiteId/knowledge': typeof AppWebsitesWebsiteIdKnowledgeRoute
  '/websites/$websiteId/leads': typeof AppWebsitesWebsiteIdLeadsRoute
  '/websites/$websiteId/setup': typeof AppWebsitesWebsiteIdSetupRoute
  '/account/billing/': typeof AppAccountBillingIndexRoute
  '/account/billing/invoices/$invoiceId': typeof AppAccountBillingInvoicesInvoiceIdRoute
  '/websites/$websiteId/conversations/$conversationId': typeof AppWebsitesWebsiteIdConversationsConversationIdRoute
  '/websites/$websiteId/custom-data/$customPageId': typeof AppWebsitesWebsiteIdCustomDataCustomPageIdRoute
  '/websites/$websiteId/custom-data/new': typeof AppWebsitesWebsiteIdCustomDataNewRoute
  '/websites/$websiteId/conversations/': typeof AppWebsitesWebsiteIdConversationsIndexRoute
  '/websites/$websiteId/custom-data/': typeof AppWebsitesWebsiteIdCustomDataIndexRoute
}
export interface FileRoutesByTo {
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/set-password': typeof SetPasswordRoute
  '/$': typeof AppSplatRoute
  '/no-permissions': typeof AppNoPermissionsRoute
  '/no-websites': typeof AppNoWebsitesRoute
  '/settings': typeof AppSettingsRoute
  '/signup/check-email': typeof SignupCheckEmailRoute
  '/verify-email/resend': typeof VerifyEmailResendRoute
  '/': typeof AppIndexRoute
  '/signup': typeof SignupIndexRoute
  '/verify-email': typeof VerifyEmailIndexRoute
  '/account/affiliate': typeof AppAccountAffiliateRoute
  '/account/analytics': typeof AppAccountAnalyticsRoute
  '/account/users': typeof AppAccountUsersRoute
  '/support/$ticketId': typeof AppSupportTicketIdRoute
  '/websites/$websiteId': typeof AppWebsitesWebsiteIdRouteWithChildren
  '/websites/new': typeof AppWebsitesNewRoute
  '/support': typeof AppSupportIndexRoute
  '/integrations/hubspot/callback': typeof AppIntegrationsHubspotCallbackRoute
  '/integrations/salesforce/callback': typeof AppIntegrationsSalesforceCallbackRoute
  '/integrations/slack/callback': typeof AppIntegrationsSlackCallbackRoute
  '/integrations/zoho/callback': typeof AppIntegrationsZohoCallbackRoute
  '/websites/$websiteId/analytics': typeof AppWebsitesWebsiteIdAnalyticsRoute
  '/websites/$websiteId/integrations': typeof AppWebsitesWebsiteIdIntegrationsRoute
  '/websites/$websiteId/knowledge': typeof AppWebsitesWebsiteIdKnowledgeRoute
  '/websites/$websiteId/leads': typeof AppWebsitesWebsiteIdLeadsRoute
  '/websites/$websiteId/setup': typeof AppWebsitesWebsiteIdSetupRoute
  '/account/billing': typeof AppAccountBillingIndexRoute
  '/account/billing/invoices/$invoiceId': typeof AppAccountBillingInvoicesInvoiceIdRoute
  '/websites/$websiteId/conversations/$conversationId': typeof AppWebsitesWebsiteIdConversationsConversationIdRoute
  '/websites/$websiteId/custom-data/$customPageId': typeof AppWebsitesWebsiteIdCustomDataCustomPageIdRoute
  '/websites/$websiteId/custom-data/new': typeof AppWebsitesWebsiteIdCustomDataNewRoute
  '/websites/$websiteId/conversations': typeof AppWebsitesWebsiteIdConversationsIndexRoute
  '/websites/$websiteId/custom-data': typeof AppWebsitesWebsiteIdCustomDataIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/set-password': typeof SetPasswordRoute
  '/_app/$': typeof AppSplatRoute
  '/_app/no-permissions': typeof AppNoPermissionsRoute
  '/_app/no-websites': typeof AppNoWebsitesRoute
  '/_app/settings': typeof AppSettingsRoute
  '/signup/check-email': typeof SignupCheckEmailRoute
  '/verify-email/resend': typeof VerifyEmailResendRoute
  '/_app/': typeof AppIndexRoute
  '/signup/': typeof SignupIndexRoute
  '/verify-email/': typeof VerifyEmailIndexRoute
  '/_app/account/affiliate': typeof AppAccountAffiliateRoute
  '/_app/account/analytics': typeof AppAccountAnalyticsRoute
  '/_app/account/users': typeof AppAccountUsersRoute
  '/_app/support/$ticketId': typeof AppSupportTicketIdRoute
  '/_app/websites/$websiteId': typeof AppWebsitesWebsiteIdRouteWithChildren
  '/_app/websites/new': typeof AppWebsitesNewRoute
  '/_app/support/': typeof AppSupportIndexRoute
  '/_app/integrations/hubspot/callback': typeof AppIntegrationsHubspotCallbackRoute
  '/_app/integrations/salesforce/callback': typeof AppIntegrationsSalesforceCallbackRoute
  '/_app/integrations/slack/callback': typeof AppIntegrationsSlackCallbackRoute
  '/_app/integrations/zoho/callback': typeof AppIntegrationsZohoCallbackRoute
  '/_app/websites/$websiteId/analytics': typeof AppWebsitesWebsiteIdAnalyticsRoute
  '/_app/websites/$websiteId/conversations': typeof AppWebsitesWebsiteIdConversationsRouteWithChildren
  '/_app/websites/$websiteId/custom-data': typeof AppWebsitesWebsiteIdCustomDataRouteWithChildren
  '/_app/websites/$websiteId/integrations': typeof AppWebsitesWebsiteIdIntegrationsRoute
  '/_app/websites/$websiteId/knowledge': typeof AppWebsitesWebsiteIdKnowledgeRoute
  '/_app/websites/$websiteId/leads': typeof AppWebsitesWebsiteIdLeadsRoute
  '/_app/websites/$websiteId/setup': typeof AppWebsitesWebsiteIdSetupRoute
  '/_app/account/billing/': typeof AppAccountBillingIndexRoute
  '/_app/account/billing/invoices/$invoiceId': typeof AppAccountBillingInvoicesInvoiceIdRoute
  '/_app/websites/$websiteId/conversations/$conversationId': typeof AppWebsitesWebsiteIdConversationsConversationIdRoute
  '/_app/websites/$websiteId/custom-data/$customPageId': typeof AppWebsitesWebsiteIdCustomDataCustomPageIdRoute
  '/_app/websites/$websiteId/custom-data/new': typeof AppWebsitesWebsiteIdCustomDataNewRoute
  '/_app/websites/$websiteId/conversations/': typeof AppWebsitesWebsiteIdConversationsIndexRoute
  '/_app/websites/$websiteId/custom-data/': typeof AppWebsitesWebsiteIdCustomDataIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/set-password'
    | '/$'
    | '/no-permissions'
    | '/no-websites'
    | '/settings'
    | '/signup/check-email'
    | '/verify-email/resend'
    | '/signup/'
    | '/verify-email/'
    | '/account/affiliate'
    | '/account/analytics'
    | '/account/users'
    | '/support/$ticketId'
    | '/websites/$websiteId'
    | '/websites/new'
    | '/support/'
    | '/integrations/hubspot/callback'
    | '/integrations/salesforce/callback'
    | '/integrations/slack/callback'
    | '/integrations/zoho/callback'
    | '/websites/$websiteId/analytics'
    | '/websites/$websiteId/conversations'
    | '/websites/$websiteId/custom-data'
    | '/websites/$websiteId/integrations'
    | '/websites/$websiteId/knowledge'
    | '/websites/$websiteId/leads'
    | '/websites/$websiteId/setup'
    | '/account/billing/'
    | '/account/billing/invoices/$invoiceId'
    | '/websites/$websiteId/conversations/$conversationId'
    | '/websites/$websiteId/custom-data/$customPageId'
    | '/websites/$websiteId/custom-data/new'
    | '/websites/$websiteId/conversations/'
    | '/websites/$websiteId/custom-data/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/set-password'
    | '/$'
    | '/no-permissions'
    | '/no-websites'
    | '/settings'
    | '/signup/check-email'
    | '/verify-email/resend'
    | '/'
    | '/signup'
    | '/verify-email'
    | '/account/affiliate'
    | '/account/analytics'
    | '/account/users'
    | '/support/$ticketId'
    | '/websites/$websiteId'
    | '/websites/new'
    | '/support'
    | '/integrations/hubspot/callback'
    | '/integrations/salesforce/callback'
    | '/integrations/slack/callback'
    | '/integrations/zoho/callback'
    | '/websites/$websiteId/analytics'
    | '/websites/$websiteId/integrations'
    | '/websites/$websiteId/knowledge'
    | '/websites/$websiteId/leads'
    | '/websites/$websiteId/setup'
    | '/account/billing'
    | '/account/billing/invoices/$invoiceId'
    | '/websites/$websiteId/conversations/$conversationId'
    | '/websites/$websiteId/custom-data/$customPageId'
    | '/websites/$websiteId/custom-data/new'
    | '/websites/$websiteId/conversations'
    | '/websites/$websiteId/custom-data'
  id:
    | '__root__'
    | '/_app'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/set-password'
    | '/_app/$'
    | '/_app/no-permissions'
    | '/_app/no-websites'
    | '/_app/settings'
    | '/signup/check-email'
    | '/verify-email/resend'
    | '/_app/'
    | '/signup/'
    | '/verify-email/'
    | '/_app/account/affiliate'
    | '/_app/account/analytics'
    | '/_app/account/users'
    | '/_app/support/$ticketId'
    | '/_app/websites/$websiteId'
    | '/_app/websites/new'
    | '/_app/support/'
    | '/_app/integrations/hubspot/callback'
    | '/_app/integrations/salesforce/callback'
    | '/_app/integrations/slack/callback'
    | '/_app/integrations/zoho/callback'
    | '/_app/websites/$websiteId/analytics'
    | '/_app/websites/$websiteId/conversations'
    | '/_app/websites/$websiteId/custom-data'
    | '/_app/websites/$websiteId/integrations'
    | '/_app/websites/$websiteId/knowledge'
    | '/_app/websites/$websiteId/leads'
    | '/_app/websites/$websiteId/setup'
    | '/_app/account/billing/'
    | '/_app/account/billing/invoices/$invoiceId'
    | '/_app/websites/$websiteId/conversations/$conversationId'
    | '/_app/websites/$websiteId/custom-data/$customPageId'
    | '/_app/websites/$websiteId/custom-data/new'
    | '/_app/websites/$websiteId/conversations/'
    | '/_app/websites/$websiteId/custom-data/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SetPasswordRoute: typeof SetPasswordRoute
  SignupCheckEmailRoute: typeof SignupCheckEmailRoute
  VerifyEmailResendRoute: typeof VerifyEmailResendRoute
  SignupIndexRoute: typeof SignupIndexRoute
  VerifyEmailIndexRoute: typeof VerifyEmailIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/set-password': {
      id: '/set-password'
      path: '/set-password'
      fullPath: '/set-password'
      preLoaderRoute: typeof SetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/$': {
      id: '/_app/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof AppSplatRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/no-permissions': {
      id: '/_app/no-permissions'
      path: '/no-permissions'
      fullPath: '/no-permissions'
      preLoaderRoute: typeof AppNoPermissionsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/no-websites': {
      id: '/_app/no-websites'
      path: '/no-websites'
      fullPath: '/no-websites'
      preLoaderRoute: typeof AppNoWebsitesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/signup/': {
      id: '/signup/'
      path: '/signup'
      fullPath: '/signup/'
      preLoaderRoute: typeof SignupIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup/check-email': {
      id: '/signup/check-email'
      path: '/signup/check-email'
      fullPath: '/signup/check-email'
      preLoaderRoute: typeof SignupCheckEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verify-email/': {
      id: '/verify-email/'
      path: '/verify-email'
      fullPath: '/verify-email/'
      preLoaderRoute: typeof VerifyEmailIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verify-email/resend': {
      id: '/verify-email/resend'
      path: '/verify-email/resend'
      fullPath: '/verify-email/resend'
      preLoaderRoute: typeof VerifyEmailResendRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/account/affiliate': {
      id: '/_app/account/affiliate'
      path: '/account/affiliate'
      fullPath: '/account/affiliate'
      preLoaderRoute: typeof AppAccountAffiliateRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/account/analytics': {
      id: '/_app/account/analytics'
      path: '/account/analytics'
      fullPath: '/account/analytics'
      preLoaderRoute: typeof AppAccountAnalyticsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/account/users': {
      id: '/_app/account/users'
      path: '/account/users'
      fullPath: '/account/users'
      preLoaderRoute: typeof AppAccountUsersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/support/': {
      id: '/_app/support/'
      path: '/support'
      fullPath: '/support/'
      preLoaderRoute: typeof AppSupportIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/support/$ticketId': {
      id: '/_app/support/$ticketId'
      path: '/support/$ticketId'
      fullPath: '/support/$ticketId'
      preLoaderRoute: typeof AppSupportTicketIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/websites/$websiteId': {
      id: '/_app/websites/$websiteId'
      path: '/websites/$websiteId'
      fullPath: '/websites/$websiteId'
      preLoaderRoute: typeof AppWebsitesWebsiteIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/websites/new': {
      id: '/_app/websites/new'
      path: '/websites/new'
      fullPath: '/websites/new'
      preLoaderRoute: typeof AppWebsitesNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/account/billing/': {
      id: '/_app/account/billing/'
      path: '/account/billing'
      fullPath: '/account/billing/'
      preLoaderRoute: typeof AppAccountBillingIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/integrations/hubspot/callback': {
      id: '/_app/integrations/hubspot/callback'
      path: '/integrations/hubspot/callback'
      fullPath: '/integrations/hubspot/callback'
      preLoaderRoute: typeof AppIntegrationsHubspotCallbackRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/integrations/salesforce/callback': {
      id: '/_app/integrations/salesforce/callback'
      path: '/integrations/salesforce/callback'
      fullPath: '/integrations/salesforce/callback'
      preLoaderRoute: typeof AppIntegrationsSalesforceCallbackRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/integrations/slack/callback': {
      id: '/_app/integrations/slack/callback'
      path: '/integrations/slack/callback'
      fullPath: '/integrations/slack/callback'
      preLoaderRoute: typeof AppIntegrationsSlackCallbackRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/integrations/zoho/callback': {
      id: '/_app/integrations/zoho/callback'
      path: '/integrations/zoho/callback'
      fullPath: '/integrations/zoho/callback'
      preLoaderRoute: typeof AppIntegrationsZohoCallbackRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/websites/$websiteId/analytics': {
      id: '/_app/websites/$websiteId/analytics'
      path: '/analytics'
      fullPath: '/websites/$websiteId/analytics'
      preLoaderRoute: typeof AppWebsitesWebsiteIdAnalyticsRouteImport
      parentRoute: typeof AppWebsitesWebsiteIdRoute
    }
    '/_app/websites/$websiteId/conversations': {
      id: '/_app/websites/$websiteId/conversations'
      path: '/conversations'
      fullPath: '/websites/$websiteId/conversations'
      preLoaderRoute: typeof AppWebsitesWebsiteIdConversationsRouteImport
      parentRoute: typeof AppWebsitesWebsiteIdRoute
    }
    '/_app/websites/$websiteId/custom-data': {
      id: '/_app/websites/$websiteId/custom-data'
      path: '/custom-data'
      fullPath: '/websites/$websiteId/custom-data'
      preLoaderRoute: typeof AppWebsitesWebsiteIdCustomDataRouteImport
      parentRoute: typeof AppWebsitesWebsiteIdRoute
    }
    '/_app/websites/$websiteId/integrations': {
      id: '/_app/websites/$websiteId/integrations'
      path: '/integrations'
      fullPath: '/websites/$websiteId/integrations'
      preLoaderRoute: typeof AppWebsitesWebsiteIdIntegrationsRouteImport
      parentRoute: typeof AppWebsitesWebsiteIdRoute
    }
    '/_app/websites/$websiteId/knowledge': {
      id: '/_app/websites/$websiteId/knowledge'
      path: '/knowledge'
      fullPath: '/websites/$websiteId/knowledge'
      preLoaderRoute: typeof AppWebsitesWebsiteIdKnowledgeRouteImport
      parentRoute: typeof AppWebsitesWebsiteIdRoute
    }
    '/_app/websites/$websiteId/leads': {
      id: '/_app/websites/$websiteId/leads'
      path: '/leads'
      fullPath: '/websites/$websiteId/leads'
      preLoaderRoute: typeof AppWebsitesWebsiteIdLeadsRouteImport
      parentRoute: typeof AppWebsitesWebsiteIdRoute
    }
    '/_app/websites/$websiteId/setup': {
      id: '/_app/websites/$websiteId/setup'
      path: '/setup'
      fullPath: '/websites/$websiteId/setup'
      preLoaderRoute: typeof AppWebsitesWebsiteIdSetupRouteImport
      parentRoute: typeof AppWebsitesWebsiteIdRoute
    }
    '/_app/account/billing/invoices/$invoiceId': {
      id: '/_app/account/billing/invoices/$invoiceId'
      path: '/account/billing/invoices/$invoiceId'
      fullPath: '/account/billing/invoices/$invoiceId'
      preLoaderRoute: typeof AppAccountBillingInvoicesInvoiceIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/websites/$websiteId/conversations/': {
      id: '/_app/websites/$websiteId/conversations/'
      path: '/'
      fullPath: '/websites/$websiteId/conversations/'
      preLoaderRoute: typeof AppWebsitesWebsiteIdConversationsIndexRouteImport
      parentRoute: typeof AppWebsitesWebsiteIdConversationsRoute
    }
    '/_app/websites/$websiteId/conversations/$conversationId': {
      id: '/_app/websites/$websiteId/conversations/$conversationId'
      path: '/$conversationId'
      fullPath: '/websites/$websiteId/conversations/$conversationId'
      preLoaderRoute: typeof AppWebsitesWebsiteIdConversationsConversationIdRouteImport
      parentRoute: typeof AppWebsitesWebsiteIdConversationsRoute
    }
    '/_app/websites/$websiteId/custom-data/': {
      id: '/_app/websites/$websiteId/custom-data/'
      path: '/'
      fullPath: '/websites/$websiteId/custom-data/'
      preLoaderRoute: typeof AppWebsitesWebsiteIdCustomDataIndexRouteImport
      parentRoute: typeof AppWebsitesWebsiteIdCustomDataRoute
    }
    '/_app/websites/$websiteId/custom-data/$customPageId': {
      id: '/_app/websites/$websiteId/custom-data/$customPageId'
      path: '/$customPageId'
      fullPath: '/websites/$websiteId/custom-data/$customPageId'
      preLoaderRoute: typeof AppWebsitesWebsiteIdCustomDataCustomPageIdRouteImport
      parentRoute: typeof AppWebsitesWebsiteIdCustomDataRoute
    }
    '/_app/websites/$websiteId/custom-data/new': {
      id: '/_app/websites/$websiteId/custom-data/new'
      path: '/new'
      fullPath: '/websites/$websiteId/custom-data/new'
      preLoaderRoute: typeof AppWebsitesWebsiteIdCustomDataNewRouteImport
      parentRoute: typeof AppWebsitesWebsiteIdCustomDataRoute
    }
  }
}

interface AppWebsitesWebsiteIdConversationsRouteChildren {
  AppWebsitesWebsiteIdConversationsConversationIdRoute: typeof AppWebsitesWebsiteIdConversationsConversationIdRoute
  AppWebsitesWebsiteIdConversationsIndexRoute: typeof AppWebsitesWebsiteIdConversationsIndexRoute
}

const AppWebsitesWebsiteIdConversationsRouteChildren: AppWebsitesWebsiteIdConversationsRouteChildren =
  {
    AppWebsitesWebsiteIdConversationsConversationIdRoute:
      AppWebsitesWebsiteIdConversationsConversationIdRoute,
    AppWebsitesWebsiteIdConversationsIndexRoute:
      AppWebsitesWebsiteIdConversationsIndexRoute,
  }

const AppWebsitesWebsiteIdConversationsRouteWithChildren =
  AppWebsitesWebsiteIdConversationsRoute._addFileChildren(
    AppWebsitesWebsiteIdConversationsRouteChildren,
  )

interface AppWebsitesWebsiteIdCustomDataRouteChildren {
  AppWebsitesWebsiteIdCustomDataCustomPageIdRoute: typeof AppWebsitesWebsiteIdCustomDataCustomPageIdRoute
  AppWebsitesWebsiteIdCustomDataNewRoute: typeof AppWebsitesWebsiteIdCustomDataNewRoute
  AppWebsitesWebsiteIdCustomDataIndexRoute: typeof AppWebsitesWebsiteIdCustomDataIndexRoute
}

const AppWebsitesWebsiteIdCustomDataRouteChildren: AppWebsitesWebsiteIdCustomDataRouteChildren =
  {
    AppWebsitesWebsiteIdCustomDataCustomPageIdRoute:
      AppWebsitesWebsiteIdCustomDataCustomPageIdRoute,
    AppWebsitesWebsiteIdCustomDataNewRoute:
      AppWebsitesWebsiteIdCustomDataNewRoute,
    AppWebsitesWebsiteIdCustomDataIndexRoute:
      AppWebsitesWebsiteIdCustomDataIndexRoute,
  }

const AppWebsitesWebsiteIdCustomDataRouteWithChildren =
  AppWebsitesWebsiteIdCustomDataRoute._addFileChildren(
    AppWebsitesWebsiteIdCustomDataRouteChildren,
  )

interface AppWebsitesWebsiteIdRouteChildren {
  AppWebsitesWebsiteIdAnalyticsRoute: typeof AppWebsitesWebsiteIdAnalyticsRoute
  AppWebsitesWebsiteIdConversationsRoute: typeof AppWebsitesWebsiteIdConversationsRouteWithChildren
  AppWebsitesWebsiteIdCustomDataRoute: typeof AppWebsitesWebsiteIdCustomDataRouteWithChildren
  AppWebsitesWebsiteIdIntegrationsRoute: typeof AppWebsitesWebsiteIdIntegrationsRoute
  AppWebsitesWebsiteIdKnowledgeRoute: typeof AppWebsitesWebsiteIdKnowledgeRoute
  AppWebsitesWebsiteIdLeadsRoute: typeof AppWebsitesWebsiteIdLeadsRoute
  AppWebsitesWebsiteIdSetupRoute: typeof AppWebsitesWebsiteIdSetupRoute
}

const AppWebsitesWebsiteIdRouteChildren: AppWebsitesWebsiteIdRouteChildren = {
  AppWebsitesWebsiteIdAnalyticsRoute: AppWebsitesWebsiteIdAnalyticsRoute,
  AppWebsitesWebsiteIdConversationsRoute:
    AppWebsitesWebsiteIdConversationsRouteWithChildren,
  AppWebsitesWebsiteIdCustomDataRoute:
    AppWebsitesWebsiteIdCustomDataRouteWithChildren,
  AppWebsitesWebsiteIdIntegrationsRoute: AppWebsitesWebsiteIdIntegrationsRoute,
  AppWebsitesWebsiteIdKnowledgeRoute: AppWebsitesWebsiteIdKnowledgeRoute,
  AppWebsitesWebsiteIdLeadsRoute: AppWebsitesWebsiteIdLeadsRoute,
  AppWebsitesWebsiteIdSetupRoute: AppWebsitesWebsiteIdSetupRoute,
}

const AppWebsitesWebsiteIdRouteWithChildren =
  AppWebsitesWebsiteIdRoute._addFileChildren(AppWebsitesWebsiteIdRouteChildren)

interface AppRouteChildren {
  AppSplatRoute: typeof AppSplatRoute
  AppNoPermissionsRoute: typeof AppNoPermissionsRoute
  AppNoWebsitesRoute: typeof AppNoWebsitesRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppIndexRoute: typeof AppIndexRoute
  AppAccountAffiliateRoute: typeof AppAccountAffiliateRoute
  AppAccountAnalyticsRoute: typeof AppAccountAnalyticsRoute
  AppAccountUsersRoute: typeof AppAccountUsersRoute
  AppSupportTicketIdRoute: typeof AppSupportTicketIdRoute
  AppWebsitesWebsiteIdRoute: typeof AppWebsitesWebsiteIdRouteWithChildren
  AppWebsitesNewRoute: typeof AppWebsitesNewRoute
  AppSupportIndexRoute: typeof AppSupportIndexRoute
  AppIntegrationsHubspotCallbackRoute: typeof AppIntegrationsHubspotCallbackRoute
  AppIntegrationsSalesforceCallbackRoute: typeof AppIntegrationsSalesforceCallbackRoute
  AppIntegrationsSlackCallbackRoute: typeof AppIntegrationsSlackCallbackRoute
  AppIntegrationsZohoCallbackRoute: typeof AppIntegrationsZohoCallbackRoute
  AppAccountBillingIndexRoute: typeof AppAccountBillingIndexRoute
  AppAccountBillingInvoicesInvoiceIdRoute: typeof AppAccountBillingInvoicesInvoiceIdRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppSplatRoute: AppSplatRoute,
  AppNoPermissionsRoute: AppNoPermissionsRoute,
  AppNoWebsitesRoute: AppNoWebsitesRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppIndexRoute: AppIndexRoute,
  AppAccountAffiliateRoute: AppAccountAffiliateRoute,
  AppAccountAnalyticsRoute: AppAccountAnalyticsRoute,
  AppAccountUsersRoute: AppAccountUsersRoute,
  AppSupportTicketIdRoute: AppSupportTicketIdRoute,
  AppWebsitesWebsiteIdRoute: AppWebsitesWebsiteIdRouteWithChildren,
  AppWebsitesNewRoute: AppWebsitesNewRoute,
  AppSupportIndexRoute: AppSupportIndexRoute,
  AppIntegrationsHubspotCallbackRoute: AppIntegrationsHubspotCallbackRoute,
  AppIntegrationsSalesforceCallbackRoute:
    AppIntegrationsSalesforceCallbackRoute,
  AppIntegrationsSlackCallbackRoute: AppIntegrationsSlackCallbackRoute,
  AppIntegrationsZohoCallbackRoute: AppIntegrationsZohoCallbackRoute,
  AppAccountBillingIndexRoute: AppAccountBillingIndexRoute,
  AppAccountBillingInvoicesInvoiceIdRoute:
    AppAccountBillingInvoicesInvoiceIdRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SetPasswordRoute: SetPasswordRoute,
  SignupCheckEmailRoute: SignupCheckEmailRoute,
  VerifyEmailResendRoute: VerifyEmailResendRoute,
  SignupIndexRoute: SignupIndexRoute,
  VerifyEmailIndexRoute: VerifyEmailIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
